import { ViewStyle } from 'react-native';

type FlattenedStyle = Record<string, unknown>;
type CircleStyle = Pick<ViewStyle, 'borderRadius'>;

/** Returns a circular border radius when the resolved style has numeric height and width. */
export function getCircleStyle(style: unknown): CircleStyle | undefined {
  const flattenedStyle = flattenStyle(style);
  const height = flattenedStyle?.height;
  const width = flattenedStyle?.width;

  if (typeof height !== 'number' || typeof width !== 'number') {
    return undefined;
  }

  return {
    borderRadius: Math.min(height, width) / 2,
  };
}

function flattenStyle(style: unknown): FlattenedStyle | undefined {
  if (!style) {
    return undefined;
  }

  if (Array.isArray(style)) {
    return style.reduce<FlattenedStyle>((flattenedStyle, styleItem) => {
      const itemStyle = flattenStyle(styleItem);

      if (!itemStyle) {
        return flattenedStyle;
      }

      return {
        ...flattenedStyle,
        ...itemStyle,
      };
    }, {});
  }

  if (typeof style !== 'object') {
    return undefined;
  }

  return style as FlattenedStyle;
}
